import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  BooleanDialogComponent,
  ConfirmDialogComponent,
  FormDialogComponent,
  FormFieldConfig,
  IBooleanDialogData,
  IConfirmData,
  IFormDialogComponentDialogData,
  IInputDialogData,
  InputDialogComponent,
} from '@shared/components';
import { ComponentType } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  openErrorDialog(
    title: string,
    message: string,
    dialogConfig?: MatDialogConfig
  ): MatDialogRef<ConfirmDialogComponent> {
    const data = {
      message: message,
      title: title,
      type: 'error',
    } as IConfirmData;

    return this.openDialog(ConfirmDialogComponent, data, dialogConfig);
  }

  openInfoDialog(
    title: string,
    message: string,
    dialogConfig?: MatDialogConfig
  ): MatDialogRef<ConfirmDialogComponent> {
    const data = {
      message: message,
      title: title,
    } as IConfirmData;

    return this.openDialog(ConfirmDialogComponent, data, dialogConfig);
  }

  openSuccessDialog(
    title: string,
    message: string,
    dialogConfig?: MatDialogConfig
  ): MatDialogRef<ConfirmDialogComponent> {
    const data = {
      message: message,
      title: title,
      type: 'success',
    } as IConfirmData;

    return this.openDialog(ConfirmDialogComponent, data, dialogConfig);
  }

  openBooleanDialog(
    title: string,
    message: string,
    question: string,
    dialogConfig?: MatDialogConfig
  ): MatDialogRef<BooleanDialogComponent> {
    const data = {
      title: title,
      message: message,
      question: question,
    } as IBooleanDialogData;
    return this.openDialog(BooleanDialogComponent, data, dialogConfig);
  }

  openInputDialog(
    title: string,
    message: string,
    okButtonText?: string,
    cancelButtonText?: string,
    formFields?: FormFieldConfig[],
    dialogConfig?: MatDialogConfig
  ): MatDialogRef<InputDialogComponent> {
    const data = {
      title: title,
      message: message,
      okButtonText: okButtonText ?? 'OK',
      cancelButtonText: cancelButtonText ?? 'Abbrechen',
      formFields: formFields ?? [],
    } as IInputDialogData;
    return this.openDialog(InputDialogComponent, data, dialogConfig);
  }

  openFormDialog(
    title: string,
    config: FormlyFieldConfig[],
    hideSubmitButton?: boolean,
    cancelText?: string,
    confirmText?: string,
    dialogConfig?: MatDialogConfig
  ): MatDialogRef<FormDialogComponent> {
    const data = {
      title: title,
      cancelText: cancelText,
      confirmText: confirmText,
      formFields: config,
      hideSubmitButton: hideSubmitButton,
    } as IFormDialogComponentDialogData;
    return this.openDialog(FormDialogComponent, data, dialogConfig);
  }

  private openDialog<T>(
    component: ComponentType<T>,
    data: IConfirmData | IBooleanDialogData | IInputDialogData | IFormDialogComponentDialogData,
    dialogConfig?: MatDialogConfig
  ): MatDialogRef<T> {
    return this.dialog.open(component, {
      ...dialogConfig,
      data,
    });
  }
}
